import goodyear0 from "@/assets/goodyear-nuerburgring-0.jpg.asset.json";
import goodyear1 from "@/assets/goodyear-nuerburgring-1.jpg.asset.json";
import goodyear2 from "@/assets/goodyear-nuerburgring-2.jpg.asset.json";
import goodyear3 from "@/assets/goodyear-nuerburgring-3.jpg.asset.json";
import goodyear4 from "@/assets/goodyear-nuerburgring-4.jpg.asset.json";
import goodyear5 from "@/assets/goodyear-nuerburgring-5.jpg.asset.json";
import harpen1 from "@/assets/harpen-bochum-1.jpg.asset.json";
import harpen2 from "@/assets/harpen-bochum-2.jpg.asset.json";
import harpen4 from "@/assets/harpen-bochum-4.jpg.asset.json";
import harpen9 from "@/assets/harpen-bochum-9.jpg.asset.json";
import harpen10 from "@/assets/harpen-bochum-10.jpg.asset.json";
import angacom1 from "@/assets/angacom-zcn-1.jpg.asset.json";
import angacom8 from "@/assets/angacom-zcn-8.jpg.asset.json";
import angacom23 from "@/assets/angacom-zcn-23.jpg.asset.json";
import angacom26 from "@/assets/angacom-zcn-26.jpg.asset.json";
import porsche38 from "@/assets/porschecup-bg-38.jpg.asset.json";
import porsche56 from "@/assets/porschecup-bg-56.jpg.asset.json";
import porsche60 from "@/assets/porschecup-bg-60.jpg.asset.json";
import porsche63 from "@/assets/porschecup-bg-63.jpg.asset.json";
import porsche80 from "@/assets/porschecup-bg-80.jpg.asset.json";
import porsche83 from "@/assets/porschecup-bg-83.jpg.asset.json";
import porsche99 from "@/assets/porschecup-bg-99.jpg.asset.json";

type BgImage = { src: string; top: string; left?: string; right?: string; rotate: number; w: string };

const pageBgImages: BgImage[] = [
  { src: harpen1.url, top: "3%", left: "-3%", rotate: -10, w: "18rem" },
  { src: angacom1.url, top: "7%", right: "-2%", rotate: 7, w: "19rem" },
  { src: porsche99.url, top: "12%", left: "6%", rotate: -7, w: "20rem" },
  { src: goodyear0.url, top: "16%", right: "5%", rotate: 9, w: "16rem" },
  { src: harpen2.url, top: "20%", right: "-2%", rotate: 8, w: "20rem" },
  { src: angacom8.url, top: "25%", left: "-3%", rotate: -8, w: "21rem" },
  { src: porsche80.url, top: "30%", right: "5%", rotate: 6, w: "18rem" },
  { src: goodyear1.url, top: "34%", left: "4%", rotate: 6, w: "14rem" },
  { src: harpen9.url, top: "38%", left: "2%", rotate: 6, w: "16rem" },
  { src: angacom26.url, top: "42%", right: "2%", rotate: 5, w: "17rem" },
  { src: porsche83.url, top: "46%", left: "8%", rotate: -5, w: "17rem" },
  { src: goodyear2.url, top: "50%", right: "8%", rotate: -9, w: "15rem" },
  { src: harpen4.url, top: "54%", right: "3%", rotate: -9, w: "19rem" },
  { src: porsche38.url, top: "58%", left: "3%", rotate: -8, w: "14rem" },
  { src: angacom23.url, top: "62%", left: "-2%", rotate: -6, w: "18rem" },
  { src: porsche56.url, top: "66%", right: "7%", rotate: 7, w: "19rem" },
  { src: goodyear3.url, top: "70%", right: "2%", rotate: -7, w: "15rem" },
  { src: harpen10.url, top: "74%", left: "-2%", rotate: 5, w: "22rem" },
  { src: porsche60.url, top: "78%", right: "12%", rotate: 8, w: "15rem" },
  { src: goodyear4.url, top: "82%", left: "38%", rotate: 4, w: "13rem" },
  { src: porsche63.url, top: "86%", left: "10%", rotate: -8, w: "18rem" },
  { src: goodyear5.url, top: "90%", left: "42%", rotate: -5, w: "12rem" },
  { src: harpen1.url, top: "94%", right: "-3%", rotate: -6, w: "17rem" },
];

const PageBackground = () => (
  <div className="absolute inset-0 pointer-events-none z-0" aria-hidden="true">
    {pageBgImages.map((img, i) => (
      <img
        key={i}
        src={img.src}
        alt=""
        loading="lazy"
        className="absolute rounded-xl shadow-2xl ring-1 ring-white/10 opacity-30"
        style={{
          top: img.top,
          left: img.left,
          right: img.right,
          width: img.w,
          transform: `rotate(${img.rotate}deg)`,
        }}
      />
    ))}
    <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/80 to-background/95" />
  </div>
);

export default PageBackground;
